import React, { useMemo } from "react"
import { PSE_STATUS } from "../../../actions/ProductionSteps/ProductionStepExecutions"
import { COLORS, roundNumber } from "../../../utils"
import { getPSEWeightGap, isPSEInsufficientWeight, PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import PSESection from "./section/PSESection"
import { StyledCardContent, StyledItemSubtitle } from "./section/StyledSections"
import { StyledItemLabel } from "../styledComponents"
import { Stack } from "@mui/material"

const sx = {
  error: {
    color: COLORS.RED_900,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.5,
  }
}

const PSEWeights = ({ productionStepExecution, isVisible = true, status }) => {
  const items = useMemo(() => {
    const isInsufficientWeightInProgress = status === PSE_STATUS.inProgress && isPSEInsufficientWeight(productionStepExecution.subStatus)

    const data = []
    if ([PSE_STATUS.todo, PSE_STATUS.locked].includes(productionStepExecution.status)) {
      data.push({
        key: "theoreticalNetWeight",
        label: "Poids final prévu",
        value: [`${roundNumber(productionStepExecution.theoreticalNetWeight, 2)} kg`]
      })
    }

    if (status === PSE_STATUS.done || isInsufficientWeightInProgress) {
      data.push({
        key: "netTheoreticalWeight",
        label: "Poids final réel/prévu",
        value: [(
          <>
            <span style={isInsufficientWeightInProgress ? sx.error : undefined}>
              {roundNumber(productionStepExecution.netWeight, 2)}
            </span>  /  {roundNumber(productionStepExecution.theoreticalNetWeight, 2)} kg
          </>
        )]
      })
      data.push({
        key: "gap",
        label: "Écart en valeur",
        value: [getPSEWeightGap(productionStepExecution)]
      })

      data.push({
        key: "gapPercentage",
        label: "Écart en %",
        value: [(
          <span key="gapPercentage" style={isInsufficientWeightInProgress ? sx.error : undefined}>
            {roundNumber((productionStepExecution.netWeight - productionStepExecution.theoreticalNetWeight) / productionStepExecution.theoreticalNetWeight * 100, 2)} %
          </span>
        )]
      })
    }

    return data
  }, [status, productionStepExecution])

  if (!isVisible) {
    return null
  }

  return (
    <PSESection
      productionStepExecution={productionStepExecution}
      sectionType={PSE_BLOCK_TYPES.WEIGHTS}
      title="Poids"
    >
      <StyledCardContent direction="row" spacing={3}>
        {items.map((item, index) => (
          <Stack key={item.value + index} spacing={1}>
            <StyledItemLabel>
              {item.label}
            </StyledItemLabel>
            {item.value.length > 0 && item.value.map((optionLabel, itemIndex) => (
              <StyledItemSubtitle key={optionLabel + itemIndex}>
                {optionLabel}
              </StyledItemSubtitle>
            ))}
          </Stack>
        ))}
      </StyledCardContent>
    </PSESection>
  )

}

export default PSEWeights